import { forwardRef } from "react";
import { SvgIcon, type SvgIconProps } from "@mui/material";

const Assembly = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => {
  return (
    <SvgIcon viewBox="0 0 32 32" ref={ref} {...props}>
      <path d="M12.267 20.978 24.4 8.845l2.489-.622L30 3.556 28.444 2l-4.667 3.111-.622 2.489-12.133 12.133-.622-.622c-.622-.622-1.556-.622-2.178 0l-5.756 5.755c-.622.622-.622 1.556 0 2.178l2.489 2.489c.622.622 1.556.622 2.178 0l5.756-5.756c.622-.622.622-1.556 0-2.178l-.622-.622zm-1.37-5.88.9.902 4.202-4.21-.9-.902c.75-2.406.3-5.112-1.651-6.917-1.801-1.804-4.502-2.406-6.904-1.654l4.802 4.812-4.202 4.361-4.802-4.812c-.75 2.406-.3 5.113 1.651 6.917s4.502 2.406 6.904 1.504zM16 20.404l9.124 9.124c.629.629 1.573.629 2.202 0l2.202-2.202c.629-.629.629-1.573 0-2.202L20.404 16 16 20.404z"/>
    </SvgIcon>
  );
});

Assembly.displayName = "Assembly";

export default Assembly;
